import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

const columns = [
  { id: "name", label: "ID", minWidth: 10 },
  { id: "code", label: "클래스 명", minWidth: 50, align: "center" },
  {
    id: "population",
    label: "이름",
    minWidth: 30,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "클래스 가격",
    minWidth: 20,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "할인 금액",
    minWidth: 20,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "최종 결제 금액",
    minWidth: 30,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "결제 여부",
    minWidth: 30,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size };
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    height: "auto",
  },
});

export default function ApplyPending({ applyEnroll, users, applyPending }) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {applyPending
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((pending) => {
                const userId = users.find((user) => user.id === pending.userId);
                return (
                  <>
                    <TableRow key={pending.id}>
                      <TableCell component="th" scope="row">
                        {pending.id}
                      </TableCell>
                      <TableCell align="center">{pending.klassTitle}</TableCell>
                      <TableCell align="center">{userId.username}</TableCell>
                      <TableCell align="center">
                        {pending.originalPrice == undefined ? (
                          "무료"
                        ) : (
                          <>
                            {String(pending.originalPrice).replace(
                              /\B(?=(\d{3})+(?!\d))/g,
                              ","
                            )}
                            원
                          </>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {pending.discountPrice == undefined ? (
                          "0원"
                        ) : (
                          <>
                            {String(pending.discountPrice).replace(
                              /\B(?=(\d{3})+(?!\d))/g,
                              ","
                            )}
                            원
                          </>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {String(pending.finalPrice).replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ","
                        )}
                        원
                      </TableCell>
                      <TableCell align="center">
                        {pending.status === "success" ? "결제완료" : "미결제"}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 100, 150]}
        component="div"
        count={applyEnroll.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
